import { ISubscriptionManagementResources } from '../subscription-management.props.autogenerated';

export function getErrorCodeMap(resources: ISubscriptionManagementResources): { [code: string]: string } {
    return {
        INVALID_CUSTOMER: resources.subManagement_errInvalidCustomer,
        PROCESS_ERROR: resources.subManagement_errProcess,
        INVALID_SUBSCRIPTION: resources.subManagement_errInvalidSubscription,
        SHIPMENT_IMMUTABLE: resources.subManagement_errShipmentImmutable,
        INVALID_EDIT: resources.subManagement_errInvalidEdit
    };
}